import { DatePicker, FormItem, TextArea } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import type { FormListFieldData } from 'antd'
import dayjs from 'dayjs'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'

type AddressFormMainPermanentResidentFieldsProps = {
  field: FormListFieldData
  t: (key: string, options?: Record<string, unknown>) => string
}

export const AddressFormMainPermanentResidentFields = ({
  field,
  t
}: AddressFormMainPermanentResidentFieldsProps) => {
  return (
    <>
      <FormItem
        {...field}
        label={<Text>{t(supConstants.ACCOMMODATION_STATUS)}</Text>}
        name={[field.name, 'accommodationDetails']}
      >
        <TextArea rows={3} maxLength={2000} showCount />
      </FormItem>
      <FormItem
        {...field}
        label={<Text>{t(supConstants.DATE_OF_OBSERVATION)}</Text>}
        name={[field.name, 'dateOfObservation']}
        getValueProps={(val: string | undefined) => ({
          value: val ? dayjs(val) : null
        })}
        getValueFromEvent={(date: dayjs.Dayjs | null) =>
          date ? date.toISOString() : null
        }
      >
        <DatePicker style={{ width: '100%' }} />
      </FormItem>
    </>
  )
}
